import { useParams } from 'react-router-dom';

import { Messages } from 'config';
import { useNavigate, handleMutation } from 'hooks';
import { useGetQuery, useEditMutation } from 'store/api/users';

import { Form } from './form';

export const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data } = useGetQuery(id!, { skip: !id });
  const [edit, mutation] = useEditMutation();

  handleMutation({
    ...mutation,
    onSuccess: () => navigate(-1),
    successMessage: `User ${Messages.UPDATED_SUCCESSFULLY}`,
  });

  if (!data) {
    return null;
  }

  return (
    <Form
      data={data}
      onSubmit={(values) => {
        if (id) {
          edit({ ...values, id, email: values.email.toLowerCase() });
        }
      }}
    />
  );
};
